import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=78c7b118&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=tsx&"
export * from "./Error.vue?vue&type=script&lang=tsx&"
import style0 from "./Error.vue?vue&type=style&index=0&id=78c7b118&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c7b118",
  null
  
)

export default component.exports